import { ConfirmConference } from 'domain/usecases/conference/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
  UnProcessableEntity,
  Conflict,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteConfirmConference implements ConfirmConference {
  private readonly url: string;

  private readonly httpClient: HttpClient<ConfirmConference.Model>;

  constructor(url: string, httClient: HttpClient<ConfirmConference.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  confirm = async (
    params: ConfirmConference.Params,
  ): Promise<ConfirmConference.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{confirmCode}', `${params.confirmCode}`),
      method: 'patch',
      body: {
        confirmation: params.confirmation,
      },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      case HttpStatusCode.conflict:
        throw new Conflict();
      case HttpStatusCode.unprocessableEntity:
        throw new UnProcessableEntity({
          ...httpResponse.body,
        });
      default:
        throw new UnexpectedError();
    }
  };
}
